import React, { Fragment, useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Container,
    Input,
    Label,
    Row,
} from "reactstrap";
import { connect } from "react-redux";
import Search from "./../../../../../../assets/img/StoreOverview_Img/search.svg";
import Campaign from "./../../../../../../assets/img/StoreOverview_Img/campaign.svg";
import Target from "./../../../../../../assets/img/StoreOverview_Img/target.svg";
import Weekly from "./../../../../../../assets/img/StoreOverview_Img/weekly.svg";
import Product from "./../../../../../../assets/img/StoreOverview_Img/product.svg";
import Campaigns from "../../../../../../designUtils/Storeoverview/Reports/Campaigns.svg"
import SearchTerms from "../../../../../../designUtils/Storeoverview/Reports/SearchTerms.svg"
import Targeting from "../../../../../../designUtils/Storeoverview/Reports/Targeting.svg"
import WeeklySales from "../../../../../../designUtils/Storeoverview/Reports/WeeklySales.svg"
import ProductPerformance from "../../../../../../designUtils/Storeoverview/Reports/ProductPerformance.svg"

import CustomModal from "../../../../../Components/Modals/CustomModal";
import PowerbiEmbed from "../../Components/PowerBI/PowerbiEmbed";
import getStoreWiseProductCatalogueDetailsService from "../../../../../../Service/DashboardServices/UserProfileServices/getStoreWiseProductCatalogueDetailsService";
import notify from '../../../../../../../src/Notifications/ToastifyActions';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronDown,
  faCloudDownloadAlt,
  faDownload
} from "@fortawesome/free-solid-svg-icons";

function StoreOverviewReports(props) {
    const [selectedProducts, setSelectedProducts] = useState([]);

    const [store, setStore] = useState(props.adProfiles[0]);
    const [reportName, setReportName] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [report, setReport] = useState("report4");
  const [loading, setLoading] = useState(false);

    var report1, report2, report3, report4, report5;

    if (store) {
        switch (report) {
            case "report1":
                var table = "AdvCampaignReportsSummary";
                var column = "IntegerId";
                report1 = (
                    <PowerbiEmbed
                        tbl_name={table}
                        col_name={column}
                        responseURL={props.CampaignPerformanceReport}
                        profileId={props.profileId}
                    />
                );
                break;
            case "report2":
                var table = "SearchTerm_Report";
                var column = "ProfileId";
                console.log(props.WeeklySearchTermReport);
                report2 = (
                    <PowerbiEmbed
                        tbl_name={table}
                        col_name={column}
                        responseURL={props.WeeklySearchTermReport}
                        profileId={props.profileId}
                    />
                );
                break;
            case "report3":
                var table = "Merge1";
                var column = "AdvTargetingSummary.ProfileId";
                report3 = (
                    <PowerbiEmbed
                        tbl_name={table}
                        col_name={column}
                        responseURL={props.TargetPerformanceReport}
                        profileId={props.profileId}
                    />
                );
                break;
            case "report4":
                var table = "newamazonadvertiserprofile";
                var column = "integerID";
                report4 = (
                    <PowerbiEmbed
                        tbl_name={table}
                        col_name={column}
                        responseURL={props.WeeklySalesReport}
                        profileId={props.profileId}
                    />
                );
                break;
            case "report5":
                // var table = "Merge2_SPAPI_Asin_sku+Merge1_Summary";
                // var column = "ProfileId";
                var table = "newproductonamazon";
                var column = "IntegerId";
                report5 = (
                    <PowerbiEmbed
                        tbl_name={table}
                        col_name={column}
                        responseURL={props.ProductPerformanceReport}
                        profileId={props.profileId}
                    />
                );
                break;

            default:
                var pageContent = <div>Report not found</div>;
        }
    }

    useEffect(() => {
        setSelectedProducts([]);
    }, [store]);

    const getCampaignPerformanceReport = () => {
        setReport("report1");
    };
    const getWeeklySearchTermReport = () => {
        setReport("report2");
    };
    const getTargetPerformanceReport = () => {
        setReport("report3");
    };
    const getWeeklySalesReport = () => {
        setReport("report4");
    };
    const getProductPerformanceReport = () => {
        setReport("report5");
    };
    const exportToCSVManagedProducts = (csvData, fileName) => {
        if (!csvData) {
          notify.NotifySuccess('Asin management data is not available for this store.')
          return true
        }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'Managed Products': ws }, SheetNames: ['Managed Products'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      };

    const now = new Date();

    // Format date: DD-MM-YY
    const day = ("0" + now.getDate()).slice(-2);
    const month = ("0" + (now.getMonth() + 1)).slice(-2);
    const year = now.getFullYear().toString().slice(-2);

    // Format time: H:MM AM/PM
    let hours = now.getHours();
    const minutes = ("0" + now.getMinutes()).slice(-2);
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // convert 0 to 12

    const formattedDateTime = `${day}-${month}-${year}_${hours}:${minutes}${ampm}`;  

    const downloadCatalogDetails = async () => {
      
        let data = {
          integerId: props.profileId
        };
      
        setLoading(true);
      
        let response = await getStoreWiseProductCatalogueDetailsService(props.token, data);
      
        console.log(response);
      
        setLoading(false);
      
        //API failed → already handled in service
        if (!response) return;
      
        //CASE 1: LARGE DATA
        if (response.status === "processing") {
          return;
        }
      
        // CASE 2: SMALL DATA → DOWNLOAD FILE
        if (response.status === "success" && response.products && response.products.length > 0) {
      
          let fileName = props.profileId && props.storeName
            ? `${props.profileId}_${props.storeName}_Catalog_${formattedDateTime}`
            : `Catalog_${formattedDateTime}`;
      
          exportToCSVManagedProducts(response.products, fileName);
          return;
        }
      
        // CASE 3: NO DATA
        notify.NotifyWarning("No products found for this store.");
      };

    const reportPage = () => (
        <>
        <Col md={12}>
        <Card className='card-of-problemarea p-3'>
            <Col md={12} className='d-flex justify-content-end'>
             {props.accessLevel === 0  && props.UserPermission.Products_DownloadManagedAsins ? (
                              <Button
                              className="btn-background-color ml-2"
                              onClick={downloadCatalogDetails}
                              disabled={loading}
                            >
                                
                              <FontAwesomeIcon
                                style={{ cursor: 'pointer', fontSize: '17px', marginRight: '10px' }}
                                icon={faDownload}
                              />
                             {loading ? "Processing..." : "Download Catalog"}
                            </Button>
                            ) : (
                              ''
                            )}</Col>
            <Col md={12} className='d-flex justify-content-between'>
            {props.UserPermission.Reports_WeeklyReports &&<h6 className={`${report==='report4'?'selected-report':'not-selected-report'}`} onClick={getWeeklySalesReport}>
                        <b>Weekly Sales</b>
                    </h6>}
                    {props.UserPermission.Reports_ProductPerformance &&<h6 className={`${report==='report5'?'selected-report':'not-selected-report'}`} onClick={getProductPerformanceReport}>
                            <b>Product Performance</b>
                        </h6>}
                        {props.UserPermission.Reports_Campaigns && <h6 className={`${report==='report1'?'selected-report':'not-selected-report'}`} onClick={getCampaignPerformanceReport}>
                        <b>Campaigns</b>
                    </h6>}
                    {props.UserPermission.Reports_SearchTerms &&  <h6 className={`${report==='report2'?'selected-report':'not-selected-report'}`} onClick={getWeeklySearchTermReport}>
                        <b>Search Terms</b>
                    </h6>}
                    {props.UserPermission.Reports_Targeting && <h6 className={`${report==='report3'?'selected-report':'not-selected-report'}`} onClick={getTargetPerformanceReport}>
                    <b>Targeting</b>
                </h6>}
            </Col>
        </Card>
        </Col>
 
   
          <Fragment>
            <Col md="12" className="pr-0 pl-3 mt-4">
                <Col md="12" className="p-0">
                    {report4?<Label className="w-100">
                        <span> {report4} </span>
                    </Label>:''}
                    {report5?<Label className="w-100">
                        <span> {report5} </span>
                    </Label>:''}
                    {report1?<Label className="w-100">
                        <span> {report1} </span>
                    </Label>:''}
                    {report2?<Label className="w-100">
                        <span> {report2} </span>
                    </Label>:''}
                    {report3?<Label className="w-100">
                        <span> {report3}  </span>
                    </Label>:''}
                </Col>
            </Col>
            <CustomModal
                header={reportName}
                isOpen={isOpen}
                toggle={() => setIsOpen(!isOpen)}
                size={"xl"}
                footer={
                    <>
                        <Button color={"link"} onClick={() => setIsOpen(!isOpen)}>
                            Cancel
                        </Button>
                    </>
                }
            ></CustomModal>
        </Fragment>
        </>
      
    );

    return (
        <Fragment>
            <div>
                
                    <Row>{reportPage()}</Row>
                
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    token: state.loggedUser.token,
    adProfiles: state.accountOverview.landing.adProfiles,
    accessLevel: state.loggedUser.accessLevel,
    // PowerBI reports
    ProductPerformanceReport: state.accountOverview.store.ProductPerformanceReport,
    TargetPerformanceReport: state.accountOverview.store.TargetPerformanceReport,
    StoreOverviewReport: state.accountOverview.store.StoreOverviewReport,
    WeeklySalesReport: state.accountOverview.store.WeeklySalesReport,
    WeeklySearchTermReport: state.accountOverview.store.WeeklySearchTermReport,
    UserPermission: state.accountOverview.store.StoreUserPermission,
    CampaignPerformanceReport: state.accountOverview.store.CampaignPerformanceReport,
});

export default connect(mapStateToProps)(StoreOverviewReports);
